import React from 'react';
import { Link } from 'react-router-dom';
import { Game } from '@lib/content';
import { siteConfig } from '../config';

/**
 * Props for GameCard component
 */
interface GameCardProps {
  /** Game object to display */
  game: Game;
  /** If provided and matches game.slug, link to homepage instead */
  mainGameSlug?: string;
}

/**
 * GameCard Component
 * 
 * Displays a game thumbnail card with title and link.
 * In single-game mode, the main game links to homepage to avoid duplicate content.
 * Component is memoized for performance optimization.
 * 
 * @component
 */
const GameCard: React.FC<GameCardProps> = ({ game, mainGameSlug }) => {
  // If this is the main game in single-game mode, link to homepage to avoid duplicate content
  const isMainGame = (siteConfig.siteMode === 'single-game' && game.slug === siteConfig.gameSlug) 
    || (mainGameSlug && game.slug === mainGameSlug);
  const linkTo = isMainGame ? '/' : `/${game.slug}`;
  
  return (
    <Link to={linkTo} className="game-title" aria-label={`Play ${game.title}`}>
      <img className="img-fluid" width={290} height={180} src={game.thumbnail} alt={`Play ${game.title} free online`} loading="lazy" />
      <h4>{game.title}</h4>
    </Link>
  );
};

// Memoize component to prevent unnecessary re-renders
export default React.memo(GameCard);
